import { render, staticRenderFns } from "./StatisticsHeader.vue?vue&type=template&id=1c6f2964&"
import script from "./StatisticsHeader.vue?vue&type=script&lang=js&"
export * from "./StatisticsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c6f2964')) {
      api.createRecord('1c6f2964', component.options)
    } else {
      api.reload('1c6f2964', component.options)
    }
    module.hot.accept("./StatisticsHeader.vue?vue&type=template&id=1c6f2964&", function () {
      api.rerender('1c6f2964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/Statistics/Page/StatisticsHeader.vue"
export default component.exports